// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".preview[data-v-37a61aa4]{position:fixed;top:0;right:0;bottom:0;left:0;animation:gradient-37a61aa4 .5s ease}@keyframes gradient-37a61aa4{0%{opacity:0}to{opacity:1}}.preview .overlay[data-v-37a61aa4]{background:rgba(0,0,0,.5);height:100%;width:100%}.preview .picture[data-v-37a61aa4]{position:absolute;top:50%;transform:translateY(-50%);width:100%;transition:transform .1s ease;transform-origin:center center}", ""]);
// Exports
module.exports = exports;
